import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { UserLayoutComponent } from '../../components/layouts/user-layout.component';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class RoutePermissionsService {
  private routes: { path: string, permission: boolean }[] = [];

  constructor(private router: Router) {
  }

  public hasPermissionForRoute(path: string): boolean {
    if (path[0] === '/') {
      return this.routes.find(r => r.path === path.substring(1))?.permission;
    }

    return this.routes.find(r => r.path === this.removeQueryParams(path))?.permission;
  }

  public getRouteByIndex(index: number): { path: string, permission: boolean } {
    return this.routes[index];
  }

  /**
   * Map all routes and set them
   */
  public prepareRoutes(): void {
    for (const config of this.router.config) {
      if (!config.component || config.component.name !== UserLayoutComponent.name) {
        continue;
      }

      for (const child of config.children) {
        if (child.path === '' || child.path === '**') {
          continue;
        }

        this.routes.push({path: child.path, permission: this.getPermissionFromRoute(child.path)});
      }
    }

    this.preparePlaylistRoutes();
  }

  /**
   * Because playlists doesn't have in root path. We need to add it manually
   * @private
   */
  private preparePlaylistRoutes(): void {
    this.routes.push({path: 'playlists', permission: environment.permissions.playlistsShow});
  }

  private getPermissionFromRoute(path: string): boolean {
    switch (path) {
      case 'live':
        return environment.permissions.liveShow;
      case 'schedules':
        return environment.permissions.recordersScheduleShow;
      case 'matches':
        return environment.permissions.matchShow;
      case 'videos':
        return environment.permissions.videoShow;
      case 'players':
        return environment.permissions.playersShow;
      case 'profile':
        return true
      case 'panels':
        return environment.permissions.eventsShowSchema;
      case 'upload':
        return environment.permissions.uploadRequest;
      case 'club-albums':
        return environment.permissions.clubAlbum;
      case 'users':
        return environment.permissions.usersShow;
      default:
        return true;
    }
  }

  private removeQueryParams(url: string): string {
    const queryIndex = url.indexOf('?');
    if (queryIndex > -1) {
      const queryParams = url.substring(queryIndex);
      return url.replace(queryParams, '');
    }

    return url;
  }
}
